/* ========================================================================
   PLP ウィッシュリストボタン状態契約
   Liquid 初期出力、swatch 切替、Wishlist Hero 連携で使う dataset と表示状態を集約する。
   ======================================================================== */
(() => {
  if (window.AuremePlpWishlistButtonData) return;

  const PLP_WISHLIST_BUTTON_SELECTOR = '.aureme-plp-card__wishlist[data-aureme-wishlist-toggle]';
  const PLP_CARD_WISHLIST_BUTTON_SELECTOR = '[data-aureme-plp-card-wishlist]';
  const PLP_WISHLIST_VARIANT_CHANGE_EVENT = 'aureme:plp:wishlist-variant-change';
  const PLP_WISHLIST_ADDED_LABEL = 'お気に入り解除';
  const PLP_WISHLIST_DEFAULT_LABEL = 'お気に入り';
  const WISHLIST_BUTTON_DATASET_FIELDS = Object.freeze({
    productHandle: 'productHandle',
    productId: 'productId',
    productImage: 'productImage',
    productOptionText: 'productOptionText',
    productPriceCents: 'productPriceCents',
    productTitle: 'productTitle',
    productUrl: 'productUrl',
    productVariantId: 'productVariantId',
    variantSku: 'variantSku',
  });

  function findButtons(scope = document) {
    return scope.querySelectorAll(PLP_WISHLIST_BUTTON_SELECTOR);
  }

  function findCardButtons(card) {
    return card?.querySelectorAll?.(PLP_CARD_WISHLIST_BUTTON_SELECTOR) || [];
  }

  function setDatasetValue(
    element,
    key,
    value,
    { removeWhenBlank = false, setWhenBlank = false } = {},
  ) {
    const normalizedValue = String(value ?? '');
    if (normalizedValue || setWhenBlank) {
      element.dataset[key] = normalizedValue;
      return;
    }

    if (removeWhenBlank) delete element.dataset[key];
  }

  /* お気に入り状態に連動する data 属性、ラベル、アイコン表示をまとめて同期する。 */
  function applyButtonAddedState(button, isAdded) {
    if (!button) return;

    const emptyIcon = button.querySelector('[data-wishlist-icon-empty]');
    const filledIcon = button.querySelector('[data-wishlist-icon-filled]');
    const normalizedIsAdded = Boolean(isAdded);

    button.dataset.added = String(normalizedIsAdded);
    button.setAttribute(
      'aria-label',
      normalizedIsAdded ? PLP_WISHLIST_ADDED_LABEL : PLP_WISHLIST_DEFAULT_LABEL,
    );

    if (emptyIcon) {
      emptyIcon.style.display = normalizedIsAdded ? 'none' : '';
    }
    if (filledIcon) {
      filledIcon.style.display = normalizedIsAdded ? '' : 'none';
    }
  }

  function syncButtonFromVariant(button, variantDataset) {
    if (!button || !variantDataset) return;

    /*
     * swatch 切替後も wishlist button DOM は再利用するため、variant 固有 dataset だけを差し替える。
     * 商品共通値は Liquid 初期出力を残し、空の optionText は前 variant の値を消す。
     */
    setDatasetValue(button, WISHLIST_BUTTON_DATASET_FIELDS.variantSku, variantDataset.variantSku);
    setDatasetValue(
      button,
      WISHLIST_BUTTON_DATASET_FIELDS.productVariantId,
      variantDataset.variantId,
    );
    setDatasetValue(button, WISHLIST_BUTTON_DATASET_FIELDS.productUrl, variantDataset.productUrl);
    if (variantDataset.price != null) {
      setDatasetValue(
        button,
        WISHLIST_BUTTON_DATASET_FIELDS.productPriceCents,
        variantDataset.price,
        {
          setWhenBlank: true,
        },
      );
    }
    setDatasetValue(button, WISHLIST_BUTTON_DATASET_FIELDS.productImage, variantDataset.mediaSrc);
    setDatasetValue(
      button,
      WISHLIST_BUTTON_DATASET_FIELDS.productOptionText,
      variantDataset.optionText || '',
      {
        removeWhenBlank: true,
      },
    );
  }

  function notifyVariantChange(card) {
    document.dispatchEvent(
      new CustomEvent(PLP_WISHLIST_VARIANT_CHANGE_EVENT, {
        detail: { card },
      }),
    );
  }

  function syncCardButtonsFromVariant(card, variantDataset) {
    for (const wishlistButton of findCardButtons(card)) {
      syncButtonFromVariant(wishlistButton, variantDataset);
    }

    /* ボタン自体は使い回すため、dataset 更新後に wishlist 側へ強制再同期を通知する */
    notifyVariantChange(card);
  }

  function readButtonDataset(button) {
    const dataset = button?.dataset || {};

    return {
      productHandle: dataset.productHandle || '',
      productId: dataset.productId || '',
      productImage: dataset.productImage || '',
      productOptionText: dataset.productOptionText || '',
      productPriceCents: dataset.productPriceCents,
      productTitle: dataset.productTitle || '',
      productUrl: dataset.productUrl || '',
      productVariantId: dataset.productVariantId || '',
      variantSku: dataset.variantSku || '',
    };
  }

  window.AuremePlpWishlistButtonData = {
    applyButtonAddedState,
    buttonSelector: PLP_WISHLIST_BUTTON_SELECTOR,
    findButtons,
    readButtonDataset,
    syncCardButtonsFromVariant,
    variantChangeEventName: PLP_WISHLIST_VARIANT_CHANGE_EVENT,
  };
})();
